import { __ } from "@wordpress/i18n";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useMenu } from '../../contexts/MenuContext';
import withForm from '../../layouts/WithForm/WithForm';
import Switch from '../../components/Switch/Switch';
import "./GlobalSettings.scss";

const GlobalSettings = ({handleChange}) =>{
	const {
		settingData
	} = useMenu();
	

	return (
		<>
			<div className="content-section">
				<div className="leftSection">
					<h2 className="title heading-1 primary-text-color semi-bold">
						{__("Enable Access Control", "access-control")}
					</h2>
					<p className="description heading-2 primary-text-color regular">
						{__(
							"Enable/disable Access Control and the frontend bar to make it easy to switch between users.",
							"access-control",
						)}
					</p>
				</div>

				<div className="rightSection">
					{/* Enable Access Control */}
					<div className="setting-item">
						<div className="input-container">
							<OverlayTrigger
								placement="top"
								overlay={
									<Tooltip id="access-control-tooltip">
										{__(
											"Enable or disable to switch from the WordPress Dashboard.",
											"access-control",
										)}
									</Tooltip>
								}
							>
								<img
									src={`${window.placAdminData.pluginUrl}/assets/images/question.svg`}
									alt="icon"
									className="icon"
								/>
							</OverlayTrigger>
							<div className="input-field">
								<span className="setting-label heading-1 primary-text-color semi-bold">
									{__("Enable Access Control", "access-control")}
								</span>
								<Switch 
									name="global_settings.settings.enable_access_control"
									checked={settingData?.global_settings?.settings?.enable_access_control} 
									onChange={handleChange} 
								/>
							</div>
						</div>
					</div>

					{/* Enable Frontend Bar */}
					<div className="setting-item">
						<div className="input-container">
							<OverlayTrigger
								placement="top"
								overlay={
									<Tooltip id="frontend-bar-tooltip">
										{__(
											"Enable or disable the frontend bar.",
											"access-control",
										)}
									</Tooltip>
								}
							>
								<img
									src={`${window.placAdminData.pluginUrl}/assets/images/question.svg`}
									alt="icon"
									className="icon"
								/>
							</OverlayTrigger>
							<div className="input-field">
								<span className="setting-label heading-1 primary-text-color semi-bold">
									{__("Enable Frontend Bar", "access-control")}
								</span>
								<Switch 
									name="global_settings.settings.enable_frontend_bar"
									checked={settingData?.global_settings?.settings?.enable_frontend_bar} 
									onChange={handleChange} 
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

		</>
	);
};

export default withForm(GlobalSettings, 'global_settings.settings');

